import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
export function SiteFooter() {
  return <footer className="bg-ink py-10 sm:py-12" data-id="element-201" data-mp="3r8rjcwvgwm1j">
      <div className="mx-auto flex max-w-shell flex-col gap-6 px-5 sm:px-6 md:flex-row md:items-center md:justify-between" data-id="element-202" data-mp="3mh9hm6lmehfi">
        <div data-id="element-203" data-mp="3hj7yjlo72i41">
          <p className="font-display text-2xl font-extrabold leading-none text-white" data-id="element-204" data-mp="3hhohhsups317">
            Arsenał Nauczyciela <span className="text-gold" data-id="element-205" data-mp="3difowrbeub78">Jazzu™</span>
          </p>
          <p className="mt-2 text-sm text-copy-soft" data-id="element-206" data-mp="38h8e0jdz0vwc">Gotowe materiały dla nauczycieli gitary jazzowej.</p>
        </div>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-center gap-2 text-sm text-copy-light transition-colors duration-150 ease-out hover:text-gold" data-id="element-207" data-mp="33jq8l2z5wyt3">
          <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-208" data-mp="11q90jy74dvxt" />
          {SUPPORT_EMAIL}
        </a>
      </div>
      <p className="mx-auto mt-8 max-w-shell border-t border-white/10 px-5 pt-6 text-xs text-copy-soft sm:px-6" data-id="element-209" data-mp="wsqow01px2m4">
        © 2026 Arsenał Nauczyciela Jazzu™ — Wszelkie prawa zastrzeżone.
      </p>
    </footer>;
}